/**
 * Resolve API / app base URLs for local + Tailscale/LAN access.
 * CRA bakes REACT_APP_* at build time (often http://localhost).
 * On a phone, localhost is the phone — use the page hostname instead.
 */
const envApiUrl = process.env.REACT_APP_API_URL || 'http://localhost';
const envAppUrl = process.env.REACT_APP_URL || 'http://localhost:3000';

function isLocalHost(url) {
  return url.includes('localhost') || url.includes('127.0.0.1');
}

function pageIsRemote() {
  if (typeof window === 'undefined') return false;
  const { hostname } = window.location;
  return hostname !== 'localhost' && hostname !== '127.0.0.1';
}

export function getApiUrl() {
  if (typeof window === 'undefined') {
    return envApiUrl;
  }

  if (isLocalHost(envApiUrl) && pageIsRemote()) {
    return `${window.location.protocol}//${window.location.hostname}`;
  }

  return envApiUrl;
}

export function getAppUrl() {
  if (typeof window === 'undefined') {
    return envAppUrl;
  }

  if (isLocalHost(envAppUrl) && pageIsRemote()) {
    return window.location.origin;
  }

  return envAppUrl;
}

export const API_URL = getApiUrl();
export const APP_URL = getAppUrl();
